import React from "react";
import "./style.css";
import axios from "axios";
import ModalStore from "./store-modal";
import AccessModal from "./access-modal";

import Asq3Icon from "../../../../assets/asq3-icon.svg";
import ScoboIcon from "../../../../assets/scobo-icon.svg";
import Gars2Icon from "../../../../assets/gars2-icon.svg";
import Gars3Icon from "../../../../assets/gars3-icon.svg";
import Wisc4Icon from "../../../../assets/wisc4-icon.svg";
import Sensory2Icon from "../../../../assets/sensoryprofile2-icon.svg";
import PanelIcon from "../../../../assets/mehrobopanel-icon.svg";

const faNumbers = require("../../../../utils/numbersFa.js");

class Store extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLogin: false,
      clinicUsers: null,
      sendMessage: "Hello,I'mInStorePage",
      evaluation: null,
      currentDateTime: null,
      openModal: false,
      errorModal: false,
      modalClinicUser: "",
      modalUserId: "",
      videocallSession: false,
      sessName: 0,
      currentUser: 0,
      products: null,
      productId: 0,
      clinicName: "",
      clinicId: 0,
      scoboCount: 1,
      gars2Count: 1,
      gars3Count: 1,
      asq3Count: 1,
      wisc4Count: 1,
      sensory2Count: 1,
      panelCount: 1,
      isWaiting: false,
      showModalStore: false,
      storeMessage: "لطفا چند لحظه منتظر بمانید ...",
    };
  }

  getCurrentDateAndTime = () => {
    var today = new Date();
    var randDate = new Date("2022-5-3 7:0:0");

    var date =
      today.getFullYear() +
      "-" +
      (today.getMonth() + 1) +
      "-" +
      today.getDate();
    var time =
      today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
    var dateTime = date + " " + time;

    console.log("Current Date is:", dateTime);
    console.log("Current Date is:", today.getTime());
    console.log("Current Date is:", randDate < today);
  };

  componentDidMount = async () => {
    const result = await axios.get("https://request.kidiar.com/user/request", {
      headers: { "x-access-token": localStorage.getItem("token") },
    });
    localStorage.setItem("currentUser", result.data.access);
    if (result.data.message == "Yo, You are authenticated!") {
      this.setState({ isLogin: true });
      this.setState({ clinicName: result.data.clinic });
      this.setState({ products: result.data.products });
      console.log(result.data);
    } else {
      // this.setState({isLogin: false});
      window.location.href = "https://www.mehrobo.com/fa/login";
    }
    this.handleRedirect();
  };

  async handleRedirect() {
    const response = await axios.post("https://request.kidiar.com/pages/request", {
      sendMe: this.state.sendMessage,
    });
  }

  modalHandler = (modal) => {
    this.setState({ showModalStore: modal });
    this.setState({ storeMessage: "لطفا چند لحظه منتظر بمانید ..." });
  };

  submitPurchase = async (prdId, prdName) => {
    var prdCount = 0;
    if (prdId == 1 || prdId == 11) {
      prdCount = this.state.scoboCount;
    } else if (prdId == 2 || prdId == 12 || prdId == 22 || prdId == 32) {
      if (prdId == 2 && prdName == "GARS2") prdCount = this.state.gars2Count;
      if (prdId == 2 && prdName == "ASQ3") prdCount = this.state.asq3Count;
      if (prdId == 12) prdCount = 10;
      if (prdId == 22) prdCount = 20;
      if (prdId == 32) prdCount = 50;
    } else if (prdId == 3 || prdId == 13 || prdId == 23 || prdId == 33) {
      if (prdId == 3 && prdName == "GARS3") prdCount = this.state.gars3Count;
      if (prdId == 3 && prdName == "SENSORY2")
        prdCount = this.state.sensory2Count;
      if (prdId == 13) prdCount = 10;
      if (prdId == 23) prdCount = 20;
      if (prdId == 33) prdCount = 50;
    } else if (prdId == 5 || prdId == 15 || prdId == 25 || prdId == 35) {
      if (prdId == 5) prdCount = 1;
      if (prdId == 15) prdCount = 3;
      if (prdId == 25) prdCount = 6;
      if (prdId == 35) prdCount = 12;
    } else if (prdId == 6) {
      if (prdId == 6) prdCount = this.state.sensory2Count;
    }

    this.setState({ showModalStore: true });
    const response = await axios.post(
      "https://request.kidiar.com/receipts/buy",
      { productname: prdName, productcount: prdCount },
      { headers: { "x-access-token": localStorage.getItem("token") } }
    );
    if (response.data.res === "SUCCESS") {
      this.setState({ storeMessage: response.data.msg });
    } else {
      this.setState({ storeMessage: response.data.msg });
    }
    // window.location.href = `https://www.sweetobot.com/bank-redirection?status=${prdId}&count=${prdCount}&CN=${tempClinicId}&PN=${prdName}&FN=None&LN=None&MN=None&WT=None`
  };

  render() {
    if (this.state.isLogin == false) {
      return <div className="container-fluid"></div>;
    }

    return (
      <div className="container-fluid">
        <div className="row no-gutters">
          {this.state.showModalStore && (
            <ModalStore
              closeModal={(modalBool) => this.modalHandler(modalBool)}
              storeMessage={this.state.storeMessage}
            />
          )}
          <div className="col-12">
            <div className="d-flex mb-3 align-items-center">
              <div className="d-flex flex-column ml-2">
                <p className="d-flex mb-2 align-items-center">
                  <span className="font-medium font-18 mode-text-2">
                    تمدید اکانت
                  </span>
                </p>
              </div>
            </div>
            <div className="boxes my-4 mb-3">
              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={PanelIcon} alt="icon-panel"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                {"۵۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">
                  {faNumbers[35] + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0 mt-0">
                  {faNumbers[1] + " ماهه"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(5, "PANEL")}
                >
                  خرید
                </button>
              </div>
              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={PanelIcon} alt="icon-panel"></img>
                </div>
                {/* <p className='mode-text-5 mb-0 font-12 line-through'>{("۷۵" + "۰٫۰۰۰" + " تومان")}</p>
                                <p className='mode-text-4 mt-0'>{("۶۷۵" + "٫۰۰۰" + " تومان")}</p> */}
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۱٫۵۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">{"۱٫۰۵" + "۰٫۰۰۰" + " تومان"}</p>
                <p className="mode-text-4 mb-0 mt-0">
                  {faNumbers[3] + " ماهه"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(15, "PANEL")}
                >
                  خرید
                </button>
              </div>
              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={PanelIcon} alt="icon-panel"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۳٫۰۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">
                  {"۱٫۸۹۰" + "٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0 mt-0">
                  {faNumbers[6] + " ماهه"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(25, "PANEL")}
                >
                  خرید
                </button>
              </div>
              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={PanelIcon} alt="icon-panel"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۶٫۰۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">
                  {"۳٫۳۶۰" + "٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0 mt-0">
                  {faNumbers[12] + " ماهه"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(35, "PANEL")}
                >
                  خرید
                </button>
              </div>
            </div>
          </div>

          <div className="col-12">
            <div className="d-flex mb-3 align-items-center">
              <div className="d-flex flex-column ml-2">
                <p className="d-flex mb-2 align-items-center">
                  <span className="font-medium font-18 mode-text-2 mt-4">
                    تست‌ها و ارزیابی‌ها
                  </span>
                </p>
              </div>
            </div>
            <div className="boxes my-4">
              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars3Icon} alt="icon-gars3"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"----"}
                </p>
                <p className="mode-text-4 mt-0">
                  {faNumbers[this.state.gars3Count * 5] + "۰٫۰۰۰" + " تومان"}
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="evaluations-add-btn d-flex align-items-center justify-content-center"
                    style={{ width: "33px", height: "33px", cursor: "pointer" }}
                    onClick={() =>
                      this.state.gars3Count < 4 &&
                      this.setState({ gars3Count: this.state.gars3Count + 1 })
                    }
                  >
                    <span style={{ fontSize: "21px" }}> + </span>
                  </div>
                  <p className="mode-text-4 mb-0 mt-0">
                    {faNumbers[this.state.gars3Count] + " عدد"}
                  </p>
                  <div
                    className="evaluations-sub-btn d-flex align-items-center justify-content-center"
                    style={{ width: "33px", height: "33px", cursor: "pointer" }}
                    onClick={() =>
                      this.state.gars3Count > 1 &&
                      this.setState({ gars3Count: this.state.gars3Count - 1 })
                    }
                  >
                    <span style={{ fontSize: "21px" }}> - </span>
                  </div>
                </div>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(3, "GARS3")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars3Icon} alt="icon-gars3"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"----"}
                </p>
                <p className="mode-text-4 mt-0">{"۵۰" + "۰٫۰۰۰" + " تومان"}</p>
                <p
                  className="mode-text-4 mb-0 mt-0"
                  style={{ minHeight: "33px" }}
                >
                  {faNumbers[10] + " عدد"}
                </p>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(13, "GARS3")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars3Icon} alt="icon-gars3"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۱٫۰۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">{"۹۰" + "۰٫۰۰۰" + " تومان"}</p>
                <p
                  className="mode-text-4 mb-0 mt-0"
                  style={{ minHeight: "33px" }}
                >
                  {faNumbers[20] + " عدد"}
                </p>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(23, "GARS3")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars3Icon} alt="icon-gars3"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۲٫۵۰۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">
                  {"۲٫۰۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p
                  className="mode-text-4 mb-0 mt-0"
                  style={{ minHeight: "33px" }}
                >
                  {faNumbers[50] + " عدد"}
                </p>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(33, "GARS3")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars2Icon} alt="icon-gars2"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"----"}
                </p>
                <p className="mode-text-4 mt-0">
                  {faNumbers[this.state.gars2Count * 3] + "۰٫۰۰۰" + " تومان"}
                </p>
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="evaluations-add-btn d-flex align-items-center justify-content-center"
                    style={{ width: "33px", height: "33px", cursor: "pointer" }}
                    onClick={() =>
                      this.state.gars2Count < 4 &&
                      this.setState({ gars2Count: this.state.gars2Count + 1 })
                    }
                  >
                    <span style={{ fontSize: "21px" }}> + </span>
                  </div>
                  <p className="mode-text-4 mb-0 mt-0">
                    {faNumbers[this.state.gars2Count] + " عدد"}
                  </p>
                  <div
                    className="evaluations-sub-btn d-flex align-items-center justify-content-center"
                    style={{ width: "33px", height: "33px", cursor: "pointer" }}
                    onClick={() =>
                      this.state.gars2Count > 1 &&
                      this.setState({ gars2Count: this.state.gars2Count - 1 })
                    }
                  >
                    <span style={{ fontSize: "21px" }}> - </span>
                  </div>
                </div>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(2, "GARS2")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars2Icon} alt="icon-gars2"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"----"}
                </p>
                <p className="mode-text-4 mt-0">{"۳۰" + "۰٫۰۰۰" + " تومان"}</p>
                <p
                  className="mode-text-4 mb-0 mt-0"
                  style={{ minHeight: "33px" }}
                >
                  {faNumbers[10] + " عدد"}
                </p>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(12, "GARS2")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars2Icon} alt="icon-gars2"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۶۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">{"۵۴" + "۰٫۰۰۰" + " تومان"}</p>
                <p
                  className="mode-text-4 mb-0 mt-0"
                  style={{ minHeight: "33px" }}
                >
                  {faNumbers[20] + " عدد"}
                </p>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(22, "GARS2")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex">
                  <img src={Gars2Icon} alt="icon-gars2"></img>
                </div>
                <p className="mode-text-5 mb-0 font-12 line-through">
                  {"۱٫۵۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mt-0">
                  {"۱٫۲۰" + "۰٫۰۰۰" + " تومان"}
                </p>
                <p
                  className="mode-text-4 mb-0 mt-0"
                  style={{ minHeight: "33px" }}
                >
                  {faNumbers[50] + " عدد"}
                </p>
                <button
                  className="font-14 mt-2 mode-text-7"
                  onClick={() => this.submitPurchase(32, "GARS2")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="evaluations-add-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({ asq3Count: this.state.asq3Count + 1 })
                    }
                  >
                    <span> + </span>
                  </div>
                  <img src={Asq3Icon} alt="icon-asq3"></img>
                  <div
                    className="evaluations-sub-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.state.asq3Count > 1 &&
                      this.setState({ asq3Count: this.state.asq3Count - 1 })
                    }
                  >
                    <span> - </span>
                  </div>
                </div>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.asq3Count * 3] + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.asq3Count] + " عدد"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(2, "ASQ3")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="evaluations-add-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({ scoboCount: this.state.scoboCount + 1 })
                    }
                  >
                    <span> + </span>
                  </div>
                  <img src={ScoboIcon} alt="icon-gars2"></img>
                  <div
                    className="evaluations-sub-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.state.scoboCount > 1 &&
                      this.setState({ scoboCount: this.state.scoboCount - 1 })
                    }
                  >
                    <span> - </span>
                  </div>
                </div>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.scoboCount * 2] + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.scoboCount] + " عدد"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(1, "SCOBO")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="evaluations-add-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({ wisc4Count: this.state.wisc4Count + 1 })
                    }
                  >
                    <span> + </span>
                  </div>
                  <img src={Wisc4Icon} alt="icon-wisc4"></img>
                  <div
                    className="evaluations-sub-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.state.wisc4Count > 1 &&
                      this.setState({ wisc4Count: this.state.wisc4Count - 1 })
                    }
                  >
                    <span> - </span>
                  </div>
                </div>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.wisc4Count * 15] + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.wisc4Count] + " عدد"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(6, "WISC4")}
                >
                  خرید
                </button>
              </div>

              <div className="box d-flex flex-column align-items-center justify-content-center">
                <div className="d-flex justify-content-center align-items-center">
                  <div
                    className="evaluations-add-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.setState({
                        sensory2Count: this.state.sensory2Count + 1,
                      })
                    }
                  >
                    <span> + </span>
                  </div>
                  <img src={Sensory2Icon} alt="icon-sensory2"></img>
                  <div
                    className="evaluations-sub-btn d-flex align-items-center justify-content-center"
                    style={{ cursor: "pointer" }}
                    onClick={() =>
                      this.state.sensory2Count > 1 &&
                      this.setState({
                        sensory2Count: this.state.sensory2Count - 1,
                      })
                    }
                  >
                    <span> - </span>
                  </div>
                </div>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.sensory2Count * 5] + "۰٫۰۰۰" + " تومان"}
                </p>
                <p className="mode-text-4 mb-0">
                  {faNumbers[this.state.sensory2Count] + " عدد"}
                </p>
                <button
                  className="font-14 mt-4 mode-text-7"
                  onClick={() => this.submitPurchase(3, "SENSORY2")}
                >
                  خرید
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Store;
